import { render, staticRenderFns } from "./importDialog.vue?vue&type=template&id=5789b080&scoped=true&"
import script from "./importDialog.vue?vue&type=script&lang=js&"
export * from "./importDialog.vue?vue&type=script&lang=js&"
import style0 from "./importDialog.vue?vue&type=style&index=0&id=5789b080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789b080",
  null
  
)

export default component.exports